// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NoMatch_notFoundPage__hKRZL","title":"NoMatch_title__yREBR","description":"NoMatch_description__bYRY4"};